export const StreamingFilterBlockConstant = "streaming";